import {
    AbstractSearchService,
    SearchResultInterface,
} from 'modules/spravochnik/dt-front-page-generator/src/Search/index';
import {Page} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';

export default class PageSearchService extends AbstractSearchService<Page> {

    filter(res: Array<SearchResultInterface>, element: Page, query: string): void {
        if (query === '') {
            this.append(res, element, null, query);
        } else {
            if (this.like(element, query)) {
                this.append(res, element, null, query);
            }
        }
    }
}
